module.exports = __webpack_public_path__ + "img/asousa.e37bc259.png";